export function iterator() {
  throw new Error('Iterator not implemented in the browser');
}
